import { render, staticRenderFns } from "./TodayCustomer.vue?vue&type=template&id=5658a74c&scoped=true&"
import script from "./TodayCustomer.vue?vue&type=script&lang=js&"
export * from "./TodayCustomer.vue?vue&type=script&lang=js&"
import style0 from "./TodayCustomer.vue?vue&type=style&index=0&id=5658a74c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5658a74c",
  null
  
)

export default component.exports